import { Phone } from "lucide-react";

import { Button } from "./ui/button";

export const CallToAction = () => {
  return (
    <section className="bg-primary py-14 text-primary-foreground">
      <div className="mx-auto flex max-w-360 flex-col items-center justify-between gap-6 px-4 text-center md:flex-row md:px-8 md:text-left">
        <div>
          <h2 className="text-2xl font-bold sm:text-3xl">
            Got an Electrical Emergency?
          </h2>
          <p className="mt-2 text-primary-foreground/80">
            Our team is on call 24/7 for urgent electrical issues. Don't wait,
            give us a call now.
          </p>
        </div>
        <Button size="lg" variant="secondary" className="shrink-0" asChild>
          <a href="tel:07850458907" className="flex items-center gap-2">
            <Phone className="size-5" />
            Call 07850 458907
          </a>
        </Button>
      </div>
    </section>
  );
};
